import React from 'react'
import styled from 'styled-components'
import { Row } from 'antd'
import { GeneralContainer } from './GeneralContainer'

type Props = {
  pageTitle: string
}

export const SmallVisor: React.FC<Props> = ({ pageTitle }) => {
  return (
    <Visor align="middle">
      <GeneralContainer>{<h1>{pageTitle}</h1>}</GeneralContainer>
    </Visor>
  )
}

const Visor = styled(Row)`
  /* El header es fijo (una franja en movil, dos desde 1024px): reservamos su
     altura con un margen superior para que el banner no quede por debajo del
     menu. Dentro, 25px de aire hasta el titulo. */
  margin: 50px 0px 80px;
  padding: 25px 0px 10px;
  width: 100%;
  background: url('/layout-images/banner-visor-p.jpg') no-repeat 100% 100%;

  @media only screen and (min-width: 1024px) {
    margin-top: 100px;
  }

  @media only screen and (min-width: 1440px) {
    background-size: cover;
  }

  h1 {
    color: #fff;
  }
`
